export default __webpack_public_path__ + "static/media/oops.5879678e.png";